import React, { useEffect, useState } from 'react'
import { Link } from 'react-scroll';
import logo from '../../Images/Logo.svg'
const NavBar = () => {
    const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 50) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const toggleMenu = () => setIsMenuOpen(!isMenuOpen);
  const closeMenu = () => setIsMenuOpen(false);
    return (
        <div>
            <nav
      className={`fixed top-0 w-full z-50 transition-all duration-300 ${
        isScrolled ? "bg-[#230202]" : "bg-transparent"
      }`}
    >
      <div className="mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16 font-khand">
          {/* Logo */}
          <div className="flex-shrink-0">
            <Link
              to="Hero" smooth={true} duration={500} offset={-64}
              className="text-white font-bold text-xl cursor-pointer"
            >
              <img src={logo} alt="Logo" width={140} height={40} />
            </Link>
          </div>

          {/* Desktop Navigation Links */}
          <div className="hidden sm:flex space-x-4">
            <Link
              to="Services" smooth={true} duration={500} offset={-64}
              className="text-sm sm:text-base md:text-lg text-white hover:text-gray-300 px-3 py-2 rounded-md cursor-pointer"
            >
              Services
            </Link>
            <Link
              to="Games" smooth={true} duration={500} offset={-64}
              className="text-sm sm:text-base md:text-lg text-white hover:text-gray-300 px-3 py-2 rounded-md cursor-pointer"
            >
              Games
            </Link>
            <Link
              to="AboutUs" smooth={true} duration={500} offset={-64}
              className="text-sm sm:text-base md:text-lg text-white hover:text-gray-300 px-3 py-2 rounded-md cursor-pointer"
            >
              About Us
            </Link>
            <Link
              to="Contact" smooth={true} duration={500} offset={-64}
              className="text-sm sm:text-base md:text-lg text-white hover:text-gray-300 px-3 py-2 rounded-md cursor-pointer"
            >
              Contact
            </Link>
          </div>

          {/* Mobile Menu Button */}
          <div className="sm:hidden">
            <button className="bg-[#800A07] text-white focus:outline-none p-2 rounded-md" onClick={toggleMenu}>
              <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
              </svg>
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Menu */}
      {isMenuOpen && (
        <div className="sm:hidden bg-[#230202] text-white p-4 space-y-4">
          <Link to="Services" smooth={true} duration={500} offset={-64} className="block text-sm sm:text-base md:text-lg px-3 py-2 rounded-md cursor-pointer" onClick={closeMenu}>
            Services
          </Link>
          <Link to="Games" smooth={true} duration={500} offset={-64} className="block text-sm sm:text-base md:text-lg px-3 py-2 rounded-md cursor-pointer" onClick={closeMenu}>
            Games
          </Link>
          <Link to="AboutUs" smooth={true} duration={500} offset={-64} className="block text-sm sm:text-base md:text-lg px-3 py-2 rounded-md cursor-pointer" onClick={closeMenu}>
            About Us
          </Link>
          <Link to="Contact" smooth={true} duration={500} offset={-64} className="block text-sm sm:text-base md:text-lg px-3 py-2 rounded-md cursor-pointer" onClick={closeMenu}>
            Contact
          </Link>
        </div>
      )}
    </nav>
        </div>
    )
}

export default NavBar